export default {"src":"/education/_next/static/media/pre.cfacfa13.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};